import type { ApiPodcastEpisode } from "../../podcast/hooks/useGetPodcastsListQuery";
import type { AudioMediaDataModel } from "../../app/contexts/audio.context";

export function convertPodcastEpisodeToMediaData(
  source: ApiPodcastEpisode,
  trackUrl: string,
  imageUrl: string
): AudioMediaDataModel {
  return {
    source,
    type: "podcast_episode",
    title: source.title,
    imageUrl,
    trackUrl,
  };
}
